module.exports = __webpack_public_path__ + "e42070b8ffac7bc622d2812eec58713c.pdf";